module.exports = __webpack_public_path__ + "media/src/images/icons/share/default-871c78c044ae35f2f160862c93455c40.svg";